import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { IconPublication } from '@hivebrite/design-system/Icon';

import EmptyState from 'hb-builder/components/common/state/EmptyState';

const EmptyPublication = () => (
  <EmptyState height="300px" isOver={false}>
    <Wrapper>
      <IconPublication size={80} />
      <TextWrapper>
        {s__('Builder|Data selection needed from the panel')}
      </TextWrapper>
    </Wrapper>
  </EmptyState>
);

export default EmptyPublication;

const TextWrapper = styled(Box).attrs(() => ({
  color: 'black',
}))``;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  color: 'primary',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}))``;
